export const BORDERS = {
  BORDER_0: `--borders-0`,
  BORDER_10: `--borders-10`,
  BORDER_20: `--borders-20`,
  BORDER_30: `--borders-30`,
} as const
export type BORDERS = (typeof BORDERS)[keyof typeof BORDERS]
